// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl:'https://suzuki-api.mint360.in/api/v1',
  baseUrl:'https://betaapi-suzuki.mint360.in/api/v1/',
  // baseUrl:'http://localhost:3009/api/v1/',
  bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
  webSocketUrl:'wss://suzuki-api.mint360.in' ,
  DD: "https://suzuki.mint360.in/",
  DP: "https://suzukimotorcycle.mint360.in/",
  GoLocal: "https://app.glocal360.ai/",
  DealerSalesExecutive:"https://play.google.com/store/apps/details?id=com.suzuki.salesmanager",
  Mint360IOS:"https://apps.apple.com/us/app/mint360lms/id6738463708",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
